import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'share-button',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnInit {
  public href: string = "";
  constructor(private router: Router) {
  }

  ngOnInit() {
    this.href = this.router.url;
  }
}
